module.exports = __webpack_public_path__ + "img/img12.9405f4d9.jpg";